import {
    isCacheL3Loaded,
    isCacheL3Loading,
    loadCacheL3,
    getProjectsById,
    getProjectsForSelect,
    onChangeInProjects,
} from "./l3";

import {
    isCacheL4Loaded,
    isCacheL4Loading,
    loadCacheL4,
    getPointOfSalesById,
    getComponentsById,
    getPointOfSalesForSelect,
    getPointOfSalesByProjectForSelect,
    getComponentsForSelect,
    getComponentByPointOfSaleForSelect,
    onChangeInPointOfSales,
    onChangeInComponents,
} from "./l4";

export const isCacheLoading = isCacheL3Loading || isCacheL4Loading;
export const isCacheLoaded = isCacheL3Loaded && isCacheL4Loaded;

export const loadCache = (list) => (dispatch) => {
    if (list.includes("l3")) {
        dispatch(loadCacheL3());
    }

    if (list.includes("l4")) {
        dispatch(loadCacheL4());
    }
};

export {
    isCacheL3Loaded, //TODO: No exportar
    isCacheL3Loading, //TODO: No exportar
    loadCacheL3,
    getProjectsById,
    getProjectsForSelect,
    onChangeInProjects,
    isCacheL4Loaded, //TODO: No exportar
    isCacheL4Loading, //TODO: No exportar
    loadCacheL4, //TODO: No exportar
    getPointOfSalesById,
    getComponentsById,
    getPointOfSalesForSelect,
    getPointOfSalesByProjectForSelect,
    getComponentsForSelect,
    getComponentByPointOfSaleForSelect,
    onChangeInPointOfSales,
    onChangeInComponents,
};
